// @flow

import styled, { css } from 'styled-components';
import { fontFamily } from '../font-family';

export const InputText = styled.input.attrs({ type: 'text' })`
  font-family: ${fontFamily.sansSerif};
  font-size: 14px;
  padding: 1em;
  height: 48px;
  background: #fff;
  border: 1px solid #cbcbcb;
  box-sizing: border-box;
  border-radius: 3px;
  color: #7f7f7f;
  outline: 0;

  ::placeholder {
    color: #d9d9d9;
  }

  :focus {
    border-color: #2196d3;
  }

  ${props => props.kind === 'error' && css`
    background-color: #fcf7f7;
    border-color: #eda8a7;

    &:focus {
      border-color: #ca2d2b;
    }
  `}
`;
